module.exports = __webpack_public_path__ + "img/avatar-ok.b177a4ec.png";